<script setup></script>

<template>
  <div class="min-h-screen flex flex-col bg-slate-50">
    <header class="sticky top-0 z-[1100] w-full bg-white shadow-lg">
      <LayoutMenuTopIrol class="hidden lg:block" />
      <LayoutMenuMainIrol />
    </header>
    <main class="flex-grow">
      <slot />
    </main>
    <footer>
      <LayoutFooterMain />
    </footer>
  </div>
</template>
